import React, { useRef, useState } from 'react';
import BlockTitle from './blockTitle';
import { MdSend } from "react-icons/md";
import emailjs from '@emailjs/browser';
import { SERVICE_ID, TEMPLETE_ID, PUBLIC_KEY } from '../helpers/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ContactForm() {
    const [loading, setLoading] = useState(false);
    const form = useRef();

    function sendEmail(e) {
        setLoading(true)
        e.preventDefault();

        emailjs.sendForm(SERVICE_ID, TEMPLETE_ID, form.current, PUBLIC_KEY)
            .then((result) => {
                console.log(result.text);
                toast.success('Your message has been sent!', {
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setLoading(false);
                e.target.reset();
            }, (error) => {

                console.log('error', error.text);
                toast.error('Something went wrong!', {
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setLoading(false);

            });
    }
    return (
        <div className="form-holder">
            <div data-aos="fade-up" data-aos-delay="1000">
            <BlockTitle
                mainTitle='contact us'
                headDesc='Just write us a message!'
            />
            </div>
            <form className='form' ref={form} onSubmit={sendEmail}>
                <div className="form-group">
                    <input type="text" name='user_name' placeholder='Name:' autoComplete='off' required className='form-control' />
                </div>
                <div className="form-group">
                    <input type="email" name='user_email' placeholder='Enter Your Email:' autoComplete='off' required className='form-control' />
                </div>
                <div className="form-group">
                    <textarea name='message' placeholder='Write a message here...' autoComplete='off' required className='form-control'></textarea>
                </div>
                <div className="btn-wrap">
                    <button type='submit' className='btn btn-primary'>
                        {loading && <span className="loader"></span>}
                        send<MdSend /></button>
                </div>
            </form>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
}

export default ContactForm;